import React from "react";
import { Select, Button, Switch } from "antd";
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from "react-sortable-hoc";

import Filter from "./Filter";
import AddFilter from "./AddFilter";

const Option = Select.Option;

const filters = [
  {
    title: "Confidence",
    variants: "60,772",
    genes: "17,138",
    types: [
      {
        title: "Call quality",
        value: 20,
        hide: false
      },
      {
        title: "Read depth",
        value: 10,
        hide: true
      }
    ]
  },
  {
    title: "Genetic Analysis",
    variants: "16",
    genes: "24",
    types: [
      {
        title: "Keep only",
        value: 10,
        hide: true
      }
    ]
  }
];

function handleChange(value) {
  console.log(`selected ${value}`);
}

const SortableItem = SortableElement(({ value }) => <Filter params={value} />);

const SortableList = SortableContainer(({ items }) => {
  return (
    <div className="filters__list">
      {items.map((value, i) => (
        <SortableItem key={`item-${i}`} index={i} value={value} />
      ))}
    </div>
  );
});

class Filters extends React.Component {
  constructor() {
    super();
    this.state = {
      filters: filters
    };
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    this.setState({
      filters: arrayMove(this.state.filters, oldIndex, newIndex)
    });
  };

  render() {
    const { filters } = this.state;
    return (
      <div className="filters">
        <div className="filters__container">
          <div className="filters__head">
            <div className="filters__row">
              <div className="filters__cell">
                <div className="filters__title">Hypothesis Filter</div>
                <div className="switch">
                  <Switch size="small" defaultChecked />
                  <div className="switch__label">Live recalculation</div>
                </div>
              </div>
              <div className="filters__cell">
                <div className="filters__param">Variants</div>
                <div className="filters__value">60,772</div>
              </div>
              <div className="filters__cell">
                <div className="filters__param">Genes</div>
                <div className="filters__value">17,138</div>
              </div>
            </div>
          </div>
          <div className="filters__body">
            <SortableList
              helperClass="filters__item_dragging"
              items={filters}
              onSortEnd={this.onSortEnd}
              useDragHandle={true}
            />
            <div className="filters__center">
              <AddFilter />
            </div>
          </div>
        </div>
        <div className="filters__foot">
          <div className="filters__templates">
            <Select
              placeholder="Select filter template"
              onChange={handleChange}
            >
              <Option value="Filter template 1">Filter template 1</Option>
              <Option value="Filter template 2">Filter template 2</Option>
              <Option value="Filter template 3">Filter template 3</Option>
              <Option value="Filter template 4">Filter template 4</Option>
            </Select>
            <Button type="primary">Save</Button>
          </div>
        </div>
        <div className="filters__categories">
          <div className="filters__category active">DeNovo</div>
          <div className="filters__category">Dominant</div>
          <div className="filters__category">Recessive</div>
        </div>
      </div>
    );
  }
}

export default Filters;
